// extracted by extract-css-chunks-webpack-plugin
module.exports = {"header":"styles__header___3LBEO","title":"styles__title___4c21p","link":"styles__link___1sYNl","link-svg":"styles__link-svg___3MEAS","linkSvg":"styles__link-svg___3MEAS"};
    if(module.hot) {
      // 1745801683280
      var cssReload = require("../../../../../node_modules/extract-css-chunks-webpack-plugin/dist/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}","cssModules":true});
      module.hot.dispose(cssReload);
      ;
    }
  